"use client";
import type { PropsWithChildren } from "react";
import type { BrowserSession } from "./browser-session-state";
import { BrowserSessionScope } from "./browser-session-scope";
import { useBrowserSessionOwner } from "./use-browser-session-owner";

export function BrowserSessionProvider({
  initialSession,
  children,
}: PropsWithChildren<{
  readonly initialSession?: BrowserSession | null;
}>) {
  const session = useBrowserSessionOwner({ initialSession });
  return <BrowserSessionScope value={session}>{children}</BrowserSessionScope>;
}
